import { render, staticRenderFns } from "./BtnRecord.vue?vue&type=template&id=14db9bc8&scoped=true&"
import script from "./BtnRecord.vue?vue&type=script&lang=js&"
export * from "./BtnRecord.vue?vue&type=script&lang=js&"
import style0 from "./BtnRecord.vue?vue&type=style&index=0&id=14db9bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14db9bc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14db9bc8')) {
      api.createRecord('14db9bc8', component.options)
    } else {
      api.reload('14db9bc8', component.options)
    }
    module.hot.accept("./BtnRecord.vue?vue&type=template&id=14db9bc8&scoped=true&", function () {
      api.rerender('14db9bc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/ExtendMenu/RoomRecord/BtnRecord.vue"
export default component.exports